import { Link } from "react-router";
import { useTownStore } from "../state/store";
import { Dialog } from "./Dialog";
import { StatsOverview } from "./StatsOverview";

/** Statistics overlay opened from the HUD; the same content lives at /stats as a full page. */
export function StatsPanel() {
  const open = useTownStore((s) => s.ui.statsOpen);
  const toggleStats = useTownStore((s) => s.toggleStats);
  if (!open) return null;
  return (
    <Dialog
      title="Town statistics"
      wide
      onClose={() => toggleStats(false)}
      footer={
        <>
          <Link className="btn btn-sm" to="/stats">
            Open full statistics page
          </Link>
          <span className="spacer" />
          <button type="button" className="btn btn-sm" onClick={() => toggleStats(false)}>
            Close
          </button>
        </>
      }
    >
      <StatsOverview active={open} headingLevel={3} />
    </Dialog>
  );
}
